'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _build = require('./build');

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _events = require('./events');

var _updates = require('./updates');

var _animations = require('./animations');

var _slideHandlers = require('./slide-handlers');

var _eventHooks = require('./event-hooks');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = createSlider;


var Slider = {
    currentSlide: 0,
    slideCount: 0,
    maxSlidePos: 0,
    minSlidePos: 0,
    previousSlide: 0,
    slideOffset: 0,
    swipePosition: 0,
    currentSwipePosition: 0,
    swipeDirection: 0,
    maxSwipePosition: 0,
    swipeIsDown: false,
    setupAnim: true,
    activeBreakpoint: 0,
    reducedAnimationApplied: false,
    animationUnapplied: false,
    init: init,

    elements: null,
    config: null,
    events: null,
    subscribers: null,
    originalOpions: null,
    responsiveOptions: null,
    breakpoints: null,

    changeSlide: _slideHandlers.changeSlide,
    on: _eventHooks.on,
    getCurrentSlide: _util.getCurrentSlide,
    next: _util.next,
    previous: _util.previous,
    play: function play() {},
    pause: function pause() {}
};

function createSlider(selector, options, classes, arrows) {
    var slider = _extends({}, Slider);
    slider.init(selector, options, classes, arrows);
    return slider;
}

function init(selector, options, classes, arrows) {
    var sliderElement = void 0;

    if (typeof selector === 'string') {
        sliderElement = document.querySelector(selector);
    } else {
        sliderElement = selector;
    }

    if (!sliderElement) {
        return;
    }

    this.elements = {
        slider: sliderElement
    };

    this.config = _extends({}, _config2.default);
    this.events = _extends({}, this.config.events);

    var dataOptions = getDataOptions.call(this);

    if (options) {
        this.config.options = _extends({}, this.config.options, options, dataOptions);
    }
    if (classes) {
        this.config.classes = _extends({}, this.config.classes, classes);
    }
    if (arrows) {
        this.config.arrows = _extends({}, this.config.arrows, arrows);
    }

    this.subscribers = {};

    this.changeSlide = this.changeSlide.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    registerBreapoints.call(this);
    checkBreakpoints.call(this, true);
}

function getDataOptions() {
    var options = {};

    if (typeof this.elements.slider.dataset.dots !== 'undefined') {
        options.dots = this.elements.slider.dataset.dots === 'true';
    }

    if (typeof this.elements.slider.dataset.arrows !== 'undefined') {
        options.arrows = this.elements.slider.dataset.arrows === 'true';
    }

    return options;
}

function registerBreapoints() {
    var _this = this;

    if (!this.config.options.responsive || !this.config.options.responsive.length) {
        return;
    }

    var responsiveBP = this.config.options.responsive.reduce(function (acc, el) {
        if (acc[el.breakpoint]) {
            return acc;
        }

        acc[el.breakpoint] = _extends({}, _this.config.options, el.options);
        return acc;
    }, {});
    this.responsiveOptions = responsiveBP;
    this.originalOpions = this.config.options;

    var breakpoints = Object.keys(responsiveBP);
    breakpoints = breakpoints.sort(function (a, b) {
        return _this.config.options.mobileFirst ? a - b : b - a;
    });
    this.breakpoints = breakpoints;
}

function checkBreakpoints() {
    var isInitial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var windowWidth = window.innerWidth;
    var compare = this.config.options.mobileFirst ? function (a, b) {
        return a > b;
    } : function (a, b) {
        return a < b;
    };

    var breakpoints = this.breakpoints || [];

    var targetBreakpoint = breakpoints.reduce(function (acc, breakpoint) {
        return compare(windowWidth, breakpoint) ? breakpoint : acc;
    }, 0);

    if (targetBreakpoint === this.activeBreakpoint && !isInitial) {
        return;
    }

    this.activeBreakpoint = targetBreakpoint;
    refresh.call(this, isInitial);
}

function refresh() {
    var isIntial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (this.activeBreakpoint > 0) {
        this.config.options = this.responsiveOptions[this.activeBreakpoint];
    } else {
        if (this.originalOpions) {
            this.config.options = this.originalOpions;
        }
    }

    var buildMethod = isIntial ? _build.build : _build.rebuild;
    buildMethod.call(this);
    this.currentSlide = 0;
    if (this.config.options.slideStartOffset) {
        this.currentSlide = this.config.options.slideStartOffset;
    }

    if (!this.elements.prevArrow) {
        this.config.options.arrows = false;
    }

    setupObservers.call(this, isIntial);
    setupState.call(this);
    _updates.updateArrows.call(this);
    _updates.updateArrowClasses.call(this);
    _updates.updateDots.call(this);
    _animations.reduceTransition.call(this);
    _slideHandlers.slideHandler.call(this);

    if (!isIntial) {
        setTimeout(_animations.applyTransition.bind(this), 1);
    }
}

function setupState() {
    if (this.config.options.infinite && !this.config.options.fade) {
        this.slideOffset = this.config.options.slidesToShow;
        this.maxSlidePos = this.slideCount;
        this.minSlidePos = -this.config.options.slidesToShow;
    } else if (this.config.options.infinite && this.config.options.fade) {
        this.maxSlidePos = this.slideCount;
        this.minSlidePos = -1;
    } else {
        this.maxSlidePos = this.slideCount - 1;
        this.minSlidePos = 0;
    }

    setSlideWidth.call(this);
}

function setupObservers(isInitial) {
    var _this2 = this;

    if (isInitial) {
        (0, _events.resizeObserver)().subscribe(function () {
            return resize.call(_this2);
        });

        (0, _events.transitionEndObserver)(this.elements).subscribe(function () {
            _animations.applyTransition.call(_this2);

            if (_this2.config.options.fade) {
                _slideHandlers.cleanupFade.call(_this2);
            }

            if (_this2.config.options.infinite) {
                _slideHandlers.updateInfiniteSlides.call(_this2);
            }

            if (!_this2.setupAnim) {
                _eventHooks.emit.call(_this2, _this2.events.slideChangeAnimEnd, _util.getCurrentSlide.call(_this2));
            }

            _this2.setupAnim = false;
        });

        if (this.config.options.keyNavigation) {
            (0, _events.keyObserver)(this.elements).subscribe(function (increment) {
                return _this2.changeSlide(increment, true);
            });
        }

        if (this.config.options.swipe && !this.config.options.fade) {
            (0, _events.touchObserver)(this.elements).subscribe(function (data) {
                _slideHandlers.swipeHandle.call(_this2, data);
            });
        }

        if (this.config.options.autoplay && this.config.options.infinite) {
            var _autoPlayObserver = (0, _events.autoPlayObserver)(this.elements, this.config.options, function (increment) {
                return _this2.changeSlide(increment, true);
            }),
                play = _autoPlayObserver.play,
                pause = _autoPlayObserver.pause;

            this.play = play;
            this.pause = pause;
        }
    }

    if (this.config.options.arrows) {
        (0, _events.arrowObserver)(this.elements).subscribe(function (increment) {
            return _this2.changeSlide(increment, true);
        });
    }

    if (this.config.options.dots) {
        (0, _events.dotObserver)(this.elements, this.config.classes.dot).subscribe(function (slideNum) {
            return _this2.changeSlide(slideNum);
        });
    }
}

function resize() {
    setSlideWidth.call(this);
    checkBreakpoints.call(this);
}

function setSlideWidth() {
    var _elements$slides$0$ge = this.elements.slides[0].getBoundingClientRect(),
        width = _elements$slides$0$ge.width;

    this.slideWidth = width;
    if (this.config.options.infinite) {
        this.maxSwipePosition = this.slideWidth * (this.maxSlidePos + this.config.options.slidesToShow);
    } else {
        this.maxSwipePosition = this.slideWidth * this.maxSlidePos;
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/index.js
// module id = ./resources/assets/js/src/slider/index.js
// module chunks = 0